import React from 'react';
import { Selector } from '../../../Selector';
import * as Ui from './styles';
import ChartOrder from 'src/components/Icons/chartOrder';

/**
 * Componente de item de menu, que manipula a ordenação
 * de exibicao de dados de um card
 */
function CardOrderMenu({
  /**
   * tipos de charts
   */
  types = [/* {label, value} */],
  /**
   * índice inicial da seleção
   */
  initialTypeIndex = 0,
  /**
   * propaga o evento de seleção do tipo de gráfico
   */
  onTypeChange,
  /**
   * others
   */
  ...props
}) {
  // props from styled-components
  const { className, withData } = props;

  function onChange(changes) {
    if (changes && changes.length === 0) return;
    const newSelection = changes[0];
    if (onTypeChange) onTypeChange(newSelection.value);
  }

  return (
    <Ui.Container className={className} withData={withData}>
      <Ui.Label>
        <Ui.IconContainer>
          <ChartOrder id="fontIcon" className="icon" />
        </Ui.IconContainer>
        <span>Ordenar valores do gráfico</span>
      </Ui.Label>
      <Ui.Action>
        <Selector
          placeholder="Ordenar valores do gráfico"
          type="single"
          data={types}
          onChange={onChange}
          initialSelectedIndexes={[initialTypeIndex]}
          disabled={!withData}
        />
      </Ui.Action>
    </Ui.Container>
  );
}

export default CardOrderMenu;
